export enum TeamTypeSettingsApproveBy {
	TeamMembers,
	TeamOwners,
	TeamContactPersons,
	Archivaris,
	TeamManagers
}
